import { render } from "./ErrorView.vue?vue&type=template&id=5087388a&scoped=true"
const script = {}

import "./ErrorView.vue?vue&type=style&index=0&id=5087388a&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\kerok\\OneDrive\\デスクトップ\\仕事\\資料\\iConnect模擬案件\\develop\\EUHP\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5087388a"]])

export default __exports__